export default __webpack_public_path__ + "static/media/copy.cf7800a4.vert";